import { transformGameState, useDoubleStore } from '@/context/DoubleProvider'
import { DoubleGame } from './DoubleGame'
import { useMaintenance } from '@/hooks/useMaintenance'
import { AppModals, useAppModal } from '@/context/ModalProvider'
import { useEffect } from 'react'
import { FIREBASE_PREFIX } from '@/constants/constants'
import { onValue, query, ref } from 'firebase/database'
import { FirebaseDatabase } from '@/context/FirebaseProvider'

export const Double = () => {
  const { isMaintenance } = useMaintenance()
  const modal = useAppModal()

  useEffect(() => {
    if (isMaintenance) {
      modal.openModalNew(AppModals.MaintenanceModal)
    }
  }, [])

  useEffect(() => {
    const sub = onValue(query(ref(FirebaseDatabase, `${FIREBASE_PREFIX}/double-indexer`)), (snapshot) => {
      const newState = transformGameState(snapshot.val())
      useDoubleStore.setState(newState)
    })

    return () => {
      sub()
    }
  }, [])

  return <DoubleGame />
}
